
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agentes",
      function () {
        return require("private-next-pages/agentes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agentes"])
      });
    }
  